/* The Model collections table (metaobject rpm_model_collections) for the new header search: each fitment model's category rows. */
(function () {
  'use strict';

  if (theme.searchModelCollections) return;

  const CACHE_PREFIX = 'search-model-collections';
  const ENTRY_SELECTOR = 'template[data-model-collections]';
  const OPTION_SELECTOR = 'li[role="option"]';
  const CATEGORY_NAME = '.results-products__info span';
  // The fitment app names machines "{year} {make} {model} {trim}"; entries are keyed by "{make} {model}".
  const LEADING_YEAR = /^\d{4}\s+/;
  const WORD_BREAK = /[^\p{L}\p{N}]+/u;
  // Parsed once per catalogue scope for the page.
  const parsed = {};
  const inFlight = {};

  // Each model's category rows if they've arrived, from this page or this session's storage; null until then.
  function ready(url) {
    if (!url) return null;
    const key = cacheKey();
    if (parsed[key]) return parsed[key];
    const html = readCache(key);
    if (html) parsed[key] = parse(html);
    return parsed[key] || null;
  }

  // sections/predictive-search-model-collections.liquid, at low priority so a search's own request goes first.
  function load(url) {
    const list = ready(url);
    if (!url || list) return Promise.resolve(list);
    const key = cacheKey();
    if (!inFlight[key]) inFlight[key] = fetchEntries(url, key).finally(() => { delete inFlight[key]; });
    return inFlight[key];
  }

  function fetchEntries(url, key) {
    return fetch(url, { priority: 'low' })
      .then((response) => (response.ok ? response.text() : null))
      .then((html) => {
        if (html === null) return null;
        writeCache(key, html);
        parsed[key] = parse(html);
        return parsed[key];
      })
      .catch(() => null);
  }

  // Scoped like best sellers, as a signed-in buyer's catalogue can count products differently.
  function cacheKey() {
    const scope = theme.recentlyViewed && theme.recentlyViewed.cacheScope ? theme.recentlyViewed.cacheScope() : 'anon';
    return `${CACHE_PREFIX}-${scope}`;
  }

  function parse(html) {
    const holder = document.createElement('template');
    holder.innerHTML = html;
    return Array.from(holder.content.querySelectorAll(ENTRY_SELECTOR))
      .map((entry) => ({ model: (entry.dataset.model || '').trim().toLowerCase(), rows: Array.from(entry.content.querySelectorAll(OPTION_SELECTOR)) }))
      .filter((entry) => entry.model);
  }

  // The machine's model's category rows whose names match every word searched (all of them for no words): rows to copy.
  function rowsFor(list, machineName, terms) {
    const model = modelOf(list, machineName);
    return model ? model.rows.filter((row) => matches(row, terms)) : [];
  }

  // The model the machine's name starts with after its year; the longest wins, so a "Maverick R MAX" isn't read as a "Maverick R".
  function modelOf(list, machineName) {
    const name = (machineName || '').trim().toLowerCase().replace(LEADING_YEAR, '');
    const named = list.filter((entry) => name === entry.model || name.startsWith(`${entry.model} `));
    return named.sort((a, b) => b.model.length - a.model.length)[0] || null;
  }

  // As Shopify matches collection titles: every word searched starts a word of the name.
  function matches(row, terms) {
    const name = row.querySelector(CATEGORY_NAME);
    const words = wordsOf(name ? name.textContent : '');
    return terms.every((term) => words.some((word) => word.startsWith(term)));
  }

  function wordsOf(text) {
    return (text || '').toLowerCase().split(WORD_BREAK).filter(Boolean);
  }

  function readCache(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function writeCache(key, html) {
    try { sessionStorage.setItem(key, html); } catch (e) { /* quota or privacy mode: fetched again next time */ }
  }

  theme.searchModelCollections = { ready, load, rowsFor, wordsOf };
})();
